var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":_vm.destination,"target":_vm.target}},[_c('v-btn',{staticClass:"mr-2 col-xl-5",attrs:{"icon":"","outlined":""}},[_c('v-icon',{attrs:{"small":"","color":"primary"}},[_vm._v(" mdi-eye ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }